/**
 * created by huyy on 2019年04月29日
 *
 * description： 分页模块
 *
 */

import './index.scss'

import utils from 'libs/utils'
import paginationTpl from './module/pagination.dot'

export default class Pagination {
	/**
	 * description： 构造函数
	 * @param {Object} [options] 属性集合
	 * @param {String} [options.binding = #pagination] 绑定元素
	 * @param {Object} [options.pageData] 分页数据
	 * @param {Number} [options.pageData.currPage = 1] 当前页
	 * @param {Number} [options.pageData.pageSize = 10] 分页size
	 * @param {Number} [options.pageData.totalPage = 0] 总页数
	 * @param {Number} [options.pageData.totalCount = 0] 总数量
	 * @param {Function} options.callback 回调函数
	 *
	 * created by hezq on 2019年03月28日
	 *
	 */
	constructor ({
		binding = '#pagination',
		pageData = {
			currPage: 1, // 当前页
			pageSize: 10, // 分页size
			totalPage: 0 // 总页数
		},
		callback
	} = {}) {
		// 绑定的位置
		this.binding = binding
		// 页面页码显示容器
		this.pageArr = []
		// 显示...控制
		this.showDot = false
		// 分页数据
		this.pageData = pageData
		// 回调函数， 切换页码需要回调重新加载数据
		this.callback = callback
		// 初始化数据,这里必须先初始化处理数据，才能显示分页
		this.init()
	}

	/**
	 * description： 初始化数据,将传递来的数据进行处理
	 *
	 * created by huyy on 2019年04月30日
	 *
	 */
	init () {
		// 开始展示页面的位置，假设处于中间第三个
		let left = this.pageData.currPage - 1
		// 末尾展示页面位置
		let right = this.pageData.currPage + 1

		// 如果前面没有那么多个
		if (left <= 0) {
			// 展示三个
			right = right - left + 1

			// 右边数量大于总页码
			if (right > this.pageData.totalPage) {
				right = this.pageData.totalPage
			}
		} else {
			// 末尾页大于总数
			if (right >= this.pageData.totalPage) {
				right = this.pageData.totalPage
				left = right - 2
			}
		}

		// 判断左边页码不能小于0
		if (left <= 0) {
			left = 1
		}

		// 判断是否完全显示了最后的页码，如果没完全则显示...
		if (right < this.pageData.totalPage) {
			this.showDot = true
		}

		// 添加到pageArr中
		for (let i = left; i <= right; i++) {
			this.pageArr.push(i)
		}
	}

	/**
	 * description： 渲染模版
	 *
	 * created by huyy on 2019年04月2日
	 *
	 */
	render () {
		this.pageContainer = $(this.binding)

		this.pageContainer.html(utils.replacePath(paginationTpl({
			showDot: this.showDot,
			pageArr: this.pageArr,
			...this.pageData
		})))
		// 绑定事件
		this.bindEvent()
	}

	/**
	 * description： 渲染数据
	 *
	 * created by huyy on 2019年04月29日
	 *
	 */
	/**
	 * 绑定分页事件方法
	 */
	bindEvent () {
		let self = this

		// 取消之前的绑定事件
		$(this.binding).off('click')
		// 重新绑定事件
		$(this.binding).on('click', '.ind,.prev,.pageSize,.next,.end,.btn', function () {
			// 按钮被禁用或是当前页则不处理
			if ($(this).is('.disabled') || $(this).is('.cur')) {
				return
			}

			// 需要回调给页面的页码
			let page = 1

			// 点击的是页码
			if ($(this).is('.pageSize')) {
				// 拿到当前点击的页码赋值
				page = parseInt($(this).text())
			} else if ($(this).is('.btn')) {
				// 点击的是跳转,拿到当前输入的页码赋值
				page = parseInt($(self.binding).find('.input').val())

				// 判断是否是0
				if (page <= 0) {
					// 修正输入框的页码
					page = 1
				}

				// 判断是否是正整数
				if (String(page).isNegativeIntHasZero() || isNaN(page)) {
					// 修正输入框的页码
					page = self.pageData.currPage
				}
			} else if ($(this).is('.prev')) {
				// 点击的是上一页,拿到上一页的页码赋值
				page = self.pageData.currPage - 1
			} else if ($(this).is('.next')) {
				// 点击的是下一页,拿到下一页的页码赋值
				page = self.pageData.currPage + 1
			} else if ($(this).is('.ind')) {
				// 点击的是首页,拿到第一页的页码赋值
				page = 1
			} else if ($(this).is('.end')) {
				// 点击的是尾页,拿到最后一页的页码赋值
				page = self.pageData.totalPage
			}

			// 判断页码是否符合
			if (isNaN(page)) {
				return
			} else if (page <= 0) {
				page = 1
			} else if (page > self.pageData.totalPage) {
				page = self.pageData.totalPage
			}

			// 将页码回调给父组件
			self.callback(page)
			// 页面跳转置顶
			$('body,html').animate({
				scrollTop: 0
			}, 0)
		})

		// 下拉选项
		$(`${this.binding} .frame_selbox .slidkey_pagination`).on('click', function () {
			$(this).parent().find('.slidkey_pagination_hide').slideToggle(200)
			return false
		})

		// 点击收回选项
		$(`${this.binding} .slidkey_pagination_hide li`).on('click', function () {
			var stxt = $(this).text()

			self.callback(1, Number.parseInt(stxt))
			$(this).parent().slideUp(200)
			$(this).parent().parent().find('em').html(stxt)
			$(this).parent().siblings('.slidkey_pagination').addClass('on')
		})

		// 全部展开
		$(`${this.binding} a.allopen`).on('click', function () {
			self.callback(0, 0)
		})
	}
}



// WEBPACK FOOTER //
// ./src/template/dot/layout/pagination/index.js